// extracted by mini-css-extract-plugin
export default {"root":"PostItBackground_root__hsRH7","top":"PostItBackground_top__hDhCu","bottom":"PostItBackground_bottom__GzbPL"};